import React from 'react';
import { useState, useRef } from 'react';
import './App.css';
import Hero from './Components/jsx/Hero'
import Projects from './Components/jsx/Projects';
import Contact from './Components/jsx/Contact';
import About from './Components/jsx/About';
import Footer from './Components/jsx/Footer';
import ScrollToTop from './Components/jsx/ScrollToTop';
import Experience from './Components/jsx/Experience';

const App = () => {
    const projectRef = useRef(null);
    const experienceRef = useRef(null);
    const aboutRef = useRef(null);
    const contactRef = useRef(null);
    return (
        <>
            <ScrollToTop />
            <Hero projectRef={projectRef} experienceRef={experienceRef} aboutRef={aboutRef} contactRef={contactRef} />
            <Experience ref={experienceRef} />
            <Projects ref={projectRef} />
            <Contact ref={contactRef} />
            <About ref={aboutRef} />
            <Footer />
        </>
    )
}

export default App
